var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"btn-switch btn-switch--toggle"},[_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.checked},on:{"change":function($event){return _vm.$emit('click', $event)}}}),_c('span',{staticClass:"slider align-middle",attrs:{"data-testid":"toggle"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }